import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceFunctionDetailOrdertake',
  components: {
    Loading,
    FileSelectorButton
  },
  data () {
    return {
      loading: true,
      processing: false,

      // input
      inpFocusFlag1: 0,
      inpFocusFlag2: 0,
      inpFocusFlag3: 0,
      inpName1: null,
      inpName2: null,
      inpName3: null,
      inpIcon1: null,
      inpIcon2: null,
      inpIcon3: null,
      inpLabel1: null,
      inpLabel2: null,
      inpLabel3: null,
      inpKey1: '',
      inpKey2: '',
      inpKey3: '',
      buttonCount: 1,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,
      serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
      values: state => state.serviceFunctionDetail.values,
      deliveryType: state => state.serviceFunctionDetail.deliveryType,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // list
    keyList () {
      return Constants.Service.OvertakeAssignedKey
    },

    buttonCountList() {
      return Array(3)
        .fill(0)
        .map((n, index) => {
          return {
            label: index + 1,
            value: index + 1
          };
        });
    },

    // input
    inpJingleFile: {
      get () {
        return this.values.inpJingleFile
      },
      set (value) {
        this.setInputValue({
          key: 'inpJingleFile',
          value: value
        })
      }
    },
    inpServiceName: {
      get () {
        return this.values.inpServiceName
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceName',
          value: value
        })
      }
    },
    inpOvertakeGuideMessage: {
      get () {
        return this.values.inpOvertakeGuideMessage
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeGuideMessage',
          value: value
        })
      }
    },
    inpOvertakeGuideSound: {
      get () {
        return this.values.inpOvertakeGuideSound
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeGuideSound',
          value: value
        })
      }
    },
    inpOvertakeBtns: {
      get () {
        return this.values.inpOvertakeBtns
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeBtns',
          value: value
        })
      }
    },
    inpOvertakeRequestAcceptionMessage: {
      get () {
        return this.values.inpOvertakeRequestAcceptionMessage
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeRequestAcceptionMessage',
          value: value
        })
      }
    },
    inpOvertakeRequestAcceptionSound: {
      get () {
        return this.values.inpOvertakeRequestAcceptionSound
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeRequestAcceptionSound',
          value: value
        })
      }
    },
    inpOvertakeAcceptionCancelMessage: {
      get () {
        return this.values.inpOvertakeAcceptionCancelMessage
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeAcceptionCancelMessage',
          value: value
        })
      }
    },
    inpOvertakeAcceptionCancelSound: {
      get () {
        return this.values.inpOvertakeAcceptionCancelSound
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeAcceptionCancelSound',
          value: value
        })
      }
    },
    inpOvertakeRequestCancelMessage: {
      get () {
        return this.values.inpOvertakeRequestCancelMessage
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeRequestCancelMessage',
          value: value
        })
      }
    },
    inpOvertakeRequestCancelSound: {
      get () {
        return this.values.inpOvertakeRequestCancelSound
      },
      set (value) {
        this.setInputValue({
          key: 'inpOvertakeRequestCancelSound',
          value: value
        })
      }
    },

    // validate
    inpOvertakeGuideMessageIsValid () {
      return Validator.validText(this.inpOvertakeGuideMessage)
    },
    inpOvertakeRequestAcceptionMessageIsValid () {
      return Validator.validText(this.inpOvertakeRequestAcceptionMessage)
    },
    inpOvertakeAcceptionCancelMessageIsValid () {
      return Validator.validText(this.inpOvertakeAcceptionCancelMessage)
    },
    inpOvertakeRequestCancelMessageIsValid () {
      return Validator.validText(this.inpOvertakeRequestCancelMessage)
    },
    inpKey1IsValid() {
      return Validator.validText(this.inpKey1)
    },
    inpKey2IsValid() {
      return Validator.validText(this.inpKey2)
    },
    inpKey3IsValid() {
      return Validator.validText(this.inpKey3)
    },
    formIsValid () {
      let isValid =
        this.inpOvertakeGuideMessageIsValid &&
        this.inpOvertakeRequestAcceptionMessageIsValid &&
        this.inpOvertakeAcceptionCancelMessageIsValid &&
        this.inpOvertakeRequestCancelMessageIsValid
      if (this.buttonCount >= 1) {
        isValid = isValid && this.inpKey1IsValid
      }
      if (this.buttonCount >= 2) {
        isValid = isValid && this.inpKey2IsValid
      }
      if (this.buttonCount >= 3) {
        isValid = isValid && this.inpKey3IsValid
      }
      return isValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
    }),
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
    }),

    init () {
      this.inpOvertakeBtns.forEach((item, index) => {
        console.log(item)
        let no = index + 1
        this['inpFocusFlag' + no] = item.defaultFocusFlg
        this['inpName' + no] = item.btnName
        this['inpIcon' + no] = item.iconFile
        this['inpLabel' + no] = item.labelText
        this['inpKey' + no] = item.assignedKey
      })
      if (this.inpOvertakeBtns && this.inpOvertakeBtns.length > 0) {
        this.buttonCount = this.inpOvertakeBtns.length
      }

      this.loading = false
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceFunction',
        params: {
          serviceId: this.serviceUuid
        }
      })
    },

    postData () {
      this.processing = true

      // jsonb : FunctionFollow(見守り機能)
      let jsonb = {
        ordertakeGuideMessage: this.inpOvertakeGuideMessage,
        ordertakeRequestAcceptionMessage: this.inpOvertakeRequestAcceptionMessage,
        ordertakeAcceptionCancelMessage: this.inpOvertakeAcceptionCancelMessage,
        ordertakeRequestCancelMessage: this.inpOvertakeRequestCancelMessage
      }
      // ジングル音
      if (this.inpJingleFile) {
        jsonb.jingleFile = Jsonb.requestFile(this.values.jingleFile, this.inpJingleFile)
      }
      // サービス名
      if (this.inpServiceName) {
        jsonb.serviceName = this.inpServiceName
      }
      // 御用聞きガイド : 音声メッセージ
      if (this.inpOvertakeGuideSound) {
        jsonb.ordertakeGuideSound = Jsonb.requestFile(this.values.ordertakeGuideSound, this.inpOvertakeGuideSound)
      }
      // 御用聞き依頼受付 : 音声メッセージ
      if (this.inpOvertakeRequestAcceptionSound) {
        jsonb.ordertakeRequestAcceptionSound = Jsonb.requestFile(this.values.ordertakeRequestAcceptionSound, this.inpOvertakeRequestAcceptionSound)
      }
      // 御用聞き受付キャンセル : 音声メッセージ
      if (this.inpOvertakeAcceptionCancelSound) {
        jsonb.ordertakeAcceptionCancelSound = Jsonb.requestFile(this.values.ordertakeAcceptionCancelSound, this.inpOvertakeAcceptionCancelSound)
      }
      // 御用聞き依頼キャンセル : 音声メッセージ
      if (this.inpOvertakeRequestCancelSound) {
        jsonb.ordertakeRequestCancelSound = Jsonb.requestFile(this.values.ordertakeRequestCancelSound, this.inpOvertakeRequestCancelSound)
      }

      // ボタン設定
      let buttons = []
      for (let i = 0, no = 1, l = this.buttonCount; i < l; i++, no++) {
        // ボタン名・アイコン画像・ラベルのいづれかに入力があれば配列に追加
        if (Validator.validText(this['inpName' + no]) ||
          this['inpIcon' + no] !== null ||
          Validator.validText(this['inpLabel' + no])) {

          // ボタンオブジェクト
          let obj = {
            defaultFocusFlg: this['inpFocusFlag' + no]
              ? 1 : 0
          }
          if (this['inpName' + no]) {
            obj.btnName = this['inpName' + no]
          }
          if (this['inpLabel' + no]) {
            obj.labelText = this['inpLabel' + no]
          }
          if (this['inpLabel' + no]) {
            obj.assignedKey = this['inpKey' + no]
          }
          // アイコン画像
          if (this['inpIcon' + no] !== null) {
            let orgIcon = this.values.ordertakeBtns &&
              this.values.ordertakeBtns[i] ?
              this.values.ordertakeBtns[i].iconFile :
              undefined
            obj.iconFile = Jsonb.requestFile(orgIcon, this['inpIcon' + no])
          }
          // 配列に追加
          buttons.push(obj)
        }
      }
      if (buttons.length) {
        jsonb.ordertakeBtns = buttons
      }

      // リクエストパラメータ
      let parameters = {
        serviceUuid: this.serviceUuid,
        serviceFunctionUuid: this.serviceFunctionUuid,
        request: {
          ordertakeSetting: jsonb
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.functionName + '情報の登録',
              body: this.functionName + '情報を登録しました。',
            })

            // 一覧へリダイレクト
            this.turnBack()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // confirm
        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.functionName + '情報を登録しますか？'
        })
      }
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      console.log('changeFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: Jsonb.formatFile(props.data)
      })
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      console.log('deleteFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: null
      })
    },

    /**
     * ファイルの変更
     */
    changeButtonFileFromSelector (props) {
      console.log('changeButtonFileFromSelector', props)
      this.$set(this, props.name, Jsonb.formatFile(props.data))
    },
    /**
     * ファイルの削除
     */
    deleteButtonFileFromSelector (props) {
      console.log('deleteButtonFileFromSelector', props)
      this.$set(this, props.name, null)
    }
  }
}